import axios from "axios";
import {urlDomain } from '../config/constant'

const apiDomain = urlDomain();

export const Glusr_identification_Creation = (remote_IP, number) =>{
    const apiUrl = `${apiDomain}/user/identify`;
    
    const requestData = {
        username: number,
        format: "JSON",
        modid: "LEAPIN",
        ph_country: "91",
        create_user: 1,
        iso: "IN",
        glusr_usr_countryname: "India",
        screen_name: "GluserIdentification Api",
        loginusing: "",
        originalreferer: "vendors.intermesh.net:8080\/Models\/glUserContactDetails.php",
        glusr_usr_ip: remote_IP,
        ip: remote_IP,
        referer: "",
        refurl: ""
    };
    return axios.post(apiUrl, requestData, {headers: {'X-Forwarded-For': remote_IP}})
}